import * as React from "react";
function SvgIcUnpublish(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 10.715l-7.612 7.621 6.288 1.687-.261.977-7.425-1.992L3 11.576l.977-.262 1.69 6.312L13.285 10l.715.715zM4 7.817h.941V4.941H19.06V19.06h-2.876V20H20V4H4v3.817z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcUnpublish;
